import { Action } from "redux";

export type ClearCoupon = "CLEAR_COUPON";
export const CLEAR_COUPON: ClearCoupon = "CLEAR_COUPON";

export interface ClearCouponAction extends Action {
    type: ClearCoupon;
}

export function clearCoupon(): ClearCouponAction {
    return { type: CLEAR_COUPON };
}
